module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("k4Nmy"))).then(() => module.bundle.root('1iHdE'));